import { render, staticRenderFns } from "./RsaPazienteStoricoStatiRichiesteLaboratorioListComponent.vue?vue&type=template&id=e19a2688"
import script from "./RsaPazienteStoricoStatiRichiesteLaboratorioListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStoricoStatiRichiesteLaboratorioListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports